















































import Vue from 'vue'
import SignInUp from '@/components/user/Sign-in-up.vue'
import DividerWithText from '@/components/DividerWithText.vue'
import EmailValidation from '@/service/EmailValidation'
import SocialLogin from '@/components/user/SocialLogin.vue'

export default Vue.extend({
  name: 'Sign-in',
  components: {
    SignInUp,
    DividerWithText,
    SocialLogin,
  },
  computed: {
    alertMessage: function (): string {
      const source = this.$route.query.source as string
      const status = this.$route.query.status as string

      if (!(source in this.alerts)) {
        return ''
      }

      if (!(status in this.alerts[source])) {
        return ''
      }

      return this.alerts[source][status]
    },
  },
  data: () => ({
    showPassword: false,
    email: '',
    password: '',
    rememberMe: false,
    emailRules: [
      (v: string) => !!v || 'E-mail is required.',
      (v: string) =>
        EmailValidation.isValid(v) || 'Enter correct e-mail address.',
    ],
    requiredField: [(v: string) => !!v || "This field can't be empty."],
    signInBtnLoading: false,
    alerts: {
      userEmail: {
        registered: '',
        'waiting_for_parent':
          'Your account is active now. We have sent an e-mail to your parent asking for confirmation. You can sign in but we are waiting for your parent consent.',
        active: 'Your account is active now!',
      },
      parentEmail: {
        registered: '',
        'waiting_for_parent': '',
        active:
          "User's account is fully active now. Thank you for the confirmation.",
      },
    } as Record<string, Record<string, string>>,
  }),
  methods: {
    handleSubmit(ev: Event) {
      ev.preventDefault();
      // @ts-ignore
      if (!this.$refs.loginFormRef.validate()) return;

      this.signInBtnLoading = true
      this.$store
        .dispatch('authentication/signIn', {
          email: this.email,
          password: this.password,
          rememberMe: this.rememberMe,
          api: this.$api,
          returnTo: this.$route.query.returnTo,
        })
        .finally(() => {
          this.signInBtnLoading = false
        })
    }
  },
})
